export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const organization = form.organization.value.trim();
    const topic = form.topic.value.trim();
    const message = form.message.value.trim();

    // BASIC VALIDATION
    if (!name || !email || !message) {
      alert("Please fill in Name, Email, and Message.");
      return;
    }

    const to = "info@whitemountainiq.com"; // TODO: change to your inbox
    const subject = `New inquiry from ${name} — ${topic || "General"}`;
    const body =
`Name: ${name}
Email: ${email}
Organization: ${organization || "-"}
Topic: ${topic || "-"}

Message:
${message}`;

    // Open mail client
    window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <section className="section contact-hero">
        <div className="contact-hero-content">
          <h1>Let’s Build Your Next Success Story</h1>
          <p>
            Reach out to the White Mountain team for tailored programs, partnership opportunities,
            or any question you have about elevating your people and projects.
          </p>
        </div>
      </section>

      <section className="section contact-details">
        <div className="contact-grid">
          <div className="contact-card">
            <h2>Email</h2>
            <p>info@whitemountainiq.com</p>
          </div>
          <div className="contact-card">
            <h2>Phone</h2>
            <p>+ 964 (750) 2002 711</p>
          </div>
          <div className="contact-card">
            <h2>Offices</h2>
            <p>Atconz , new azadi r5/62</p>
          </div>
        </div>
      </section>

      <section className="section contact-form-section">
        <div className="contact-form-wrapper">
          <h2>Tell us about your goals</h2>
          <p>Share a few details and we’ll connect you with the right specialist within one business day.</p>

          {/* ADD onSubmit */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <label>
                Name
                <input type="text" name="name" placeholder="Your name" required />
              </label>
              <label>
                Email
                <input type="email" name="email" placeholder="you@example.com" required />
              </label>
            </div>
            <div className="form-row">
              <label>
                Organization
                <input type="text" name="organization" placeholder="Company or team name" />
              </label>
              <label>
                Topic
                <input type="text" name="topic" placeholder="Training, consulting, etc." />
              </label>
            </div>
            <label>
              How can we help?
              <textarea name="message" rows="4" placeholder="Tell us about your project or challenges" required></textarea>
            </label>

            {/* your existing styles: cta-button submit-button */}
            <button type="submit" className="cta-button submit-button">Send Message</button>
          </form>
        </div>
      </section>
    </>
  );
}
